import {
  DeleteOutlined,
  EditOutlined,
  PlusCircleOutlined
} from '@ant-design/icons';
import { Button, Form, Space, Tooltip } from 'antd';
import React, { useRef, useState } from 'react';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import CustomCopyable from '../../components/CustomCopyable';
import GenerarEnlaceModal from '../../components/GenerarEnlaceModal';
import TableAndFilters from '../../components/TableAndFilters';

const EnlaceEmpresa = () => {
  const {
    params: { id: idEmpresa }
  } = useRouteMatch();
  const tableRef = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const columns = [
    {
      title: 'Enlace Original',
      dataIndex: 'enlace_original',
      key: 'enlace_original'
    },
    {
      title: 'Enlace Corto',
      dataIndex: 'enlace_corto',
      key: 'enlace_corto'
    },
    {
      title: 'Origen',
      dataIndex: 'origen',
      key: 'origen'
    },
    {
      title: 'Campaña',
      dataIndex: 'campanha',
      key: 'campanha'
    },
    {
      title: 'Producto',
      dataIndex: ['producto', 'descripcion'],
      key: 'producto'
    },
    {
      title: 'Cantidad de Clics',
      dataIndex: 'cantidad_clics',
      key: 'cantidad_clics',
      render: (text) => <span>{text || 0}</span>
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (record) => {
        const { enlace_corto } = record;
        return (
          <Space>
            <Tooltip title="Copiar enlace">
              <CustomCopyable
                copyable={{
                  text: `${enlace_corto}`,
                  tooltips: ['Copiar enlace', 'Copiado']
                }}
              />
            </Tooltip>
            <Tooltip title="Editar">
              <Button
                type="text"
                icon={<EditOutlined />}
                size="middle"
                style={{ color: 'rgba(0,0,0,.45)' }}
                // onClick={() => updateProducto(record)}
                disabled
              />
            </Tooltip>
            <Tooltip title="Eliminar">
              <DeleteOutlined
                style={{ color: 'rgba(0,0,0,.45)' }}
                // onClick={() => handleDelete(record.row)}
                disabled
              />
            </Tooltip>
          </Space>
        );
      }
    }
  ];

  return (
    <div>
      <TableAndFilters
        ref={tableRef}
        withGeneralFilter
        url="/enlace"
        title="Enlaces"
        columns={columns}
        showTable
        hasExportar
        extra={[
          <Button
            key="enlaceAdd"
            type="dashed"
            shape="round"
            icon={<PlusCircleOutlined />}
            size="middle"
            onClick={() => setIsModalOpen(true)}
          >
            Agregar Enlace
          </Button>
        ]}
      />

      <GenerarEnlaceModal
        form={form}
        idEmpresa={idEmpresa}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </div>
  );
};

export default EnlaceEmpresa;
